import { useAppSelector } from '@/store/hooks';
import {
  selectProjectChannel,
  selectProjectGlobalTemplateType,
  selectProjectIsAutoGeneratedName,
  selectProjectName,
} from '@/store/slices/project/selectors';
import { getDisplayProjectName } from './get-project-name';

const useGetDisplayProjectName = () => {
  const isAutoGeneratedName = useAppSelector(selectProjectIsAutoGeneratedName);
  const globalTemplateType = useAppSelector(selectProjectGlobalTemplateType);
  const projectName = useAppSelector(selectProjectName);
  const channel = useAppSelector(selectProjectChannel);

  return getDisplayProjectName({ isAutoGeneratedName, globalTemplateType, projectName, channel });
};

export default useGetDisplayProjectName;
